import axios from 'axios'

const basinUrl = process.env.REACT_APP_BASIN_URL

export const sendLead = async (leadData) => {
  const {
    name,
    email,
    phone,
    associationName,
    role,
    otherRole,
    dateSubmission,
    services,
    otherService,
    satisfied,
    whyNotSatisfied,
    interestedInRecieveProposal,
    isWorkOrder,
    workOrderNo,
    noWorkOrderNo,
    workOrderComments,
    wordOrderRate,
    orderAditionalComments,
    orderRecomend,
    wantBeContactedByManagers,
    whatDidLike,
    whatImprove,
    recomendWhy,
    rate,
    testimonial,
    dateTime,
  } = leadData

  const config = {
    mode: 'cors',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }

  const servicesArray = Object.keys(services).filter((name) => services[name])
  const servicesRes = servicesArray.join(', ')

  let data = new FormData()
  data.append('Subject', 'Seacrest Services Inc. - Clients Feedback')
  data.append('Client Info:', '')
  data.append('Name:', name)
  data.append('Email:', email)
  data.append('Phone:', phone)
  data.append('Community Association Name:', associationName)
  data.append('Role:', role === 'Other' ? otherRole : role)
  if (role === 'Realtor') {
    data.append('Date of Submission: ', dateSubmission)
  }

  if (servicesArray.includes('Other')) {
    data.append('Services:', `${servicesRes}, ${otherService}`)
  } else data.append('Services:', servicesRes)

  if (servicesArray.includes('Landscaping / Irrigation / Pest Control')) {
    data.append(
      'Are you satisfied with the completion status of your request?',
      satisfied || satisfied === 'true' ? 'Yes' : 'No'
    )
    if (!satisfied || satisfied === 'false')
      data.append('Reason for non-satisfaction', whyNotSatisfied)
  }
  if (servicesArray.includes('Proposal')) {
    data.append(
      'Are you interested in receiving a proposal for our services?',
      interestedInRecieveProposal || interestedInRecieveProposal === 'true'
        ? 'Yes'
        : 'No'
    )
  }

  if (isWorkOrder) {
    data.append(
      'Workorder confirmation number:',
      noWorkOrderNo
        ? 'I do not have my work order number at this time.'
        : workOrderNo
    )
    data.append(
      'Was the work order completed to your satisfaction? Why or why not?',
      workOrderComments
    )
    data.append(
      'On a scale of 1-5 (5 being the highest), what would you rate today’s experience?',
      wordOrderRate
    )
    data.append(
      'Is there anything else you would like to share about our service/service personnel?',
      orderAditionalComments
    )
    data.append(
      'Was there something that you would recommend improving with regard to this interaction? Please explain',
      orderRecomend
    )
  } else {
    data.append(
      'What has been the best part about working with Seacrest Services?',
      whatDidLike
    )

    data.append(
      'Where does Seacrest Services have an opportunity to improve?',
      whatImprove
    )

    data.append(
      'Would you recommend our services for another Condominium or Homeowner Association Community? Why? Why not?',
      recomendWhy
    )
  }

  data.append(
    'Would you like to be contacted by one of our Managers regarding our services?',
    wantBeContactedByManagers || wantBeContactedByManagers === 'true'
      ? 'Yes'
      : 'No'
  )

  data.append('Client rating:', rate)
  data.append('Date & Time', dateTime);

  if (rate > 3) {
    data.append('Client Testimonial:', testimonial)
  }

  try {
    await axios.post(basinUrl, data, config).then(async function (response) {
      if (response.status === 200) {
        console.log('Send Email Success')
      }
    })

    return data
  } catch (err) {
    console.log(err)
    throw new Error(err)
  }
}
